import * as types from '../constants/dashboarddetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  dashboarddetails: null,
  templatedetailsList: null
}

export function dashboardDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_DASHBOARD_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_DASHBOARD_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        dashboarddetails: action.data
      };
    case types.FETCH_DASHBOARD_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // templatedetailsList:action.error
      };    
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/dashboardDetails.js